const text = {
  LOGS: 'AUTHENTICATION LOGS: ',
}

export default text
